// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1ZPLO","header":"PatientBlock_header__KjTXB","label":"PatientBlock_label__3N8AG","option":"PatientBlock_option__3p80U"};